import React from "react";
import classes from "./CompositionWeightTextStyles.module.scss";
import { BASIS_POINTS_DIVISOR } from "../../lib/legacy";
import { formatAmount } from "../../lib/numbers";
import TooltipComponent from "../Tooltip/Tooltip";
import StatsTooltipRow from "../StatsTooltip/StatsTooltipRow";
import { Link } from "react-router-dom";
import ExternalLink from "../ExternalLink/ExternalLink";
import { t, Trans } from "@lingui/macro";

type Props = {
  tokenInfo: any;
  adjustedUsdgSupply: any;
  totalTokenWeights: any;
};

export const CompositionWeightText = ({ tokenInfo, adjustedUsdgSupply, totalTokenWeights }: Props) => {
  if (
    !tokenInfo.weight ||
    !tokenInfo.usdgAmount ||
    !adjustedUsdgSupply ||
    adjustedUsdgSupply.eq(0) ||
    !totalTokenWeights
  ) {
    return <>...</>;
  }

  let currentWeightBps = tokenInfo.usdgAmount.mul(BASIS_POINTS_DIVISOR).div(adjustedUsdgSupply);

  const targetWeightBps = tokenInfo.weight.mul(BASIS_POINTS_DIVISOR).div(totalTokenWeights).add(1).div(10).mul(10);

  const weightText = `${formatAmount(currentWeightBps, 2, 2, false)}% / ${formatAmount(targetWeightBps, 2, 2, false)}%`;

  return (
    <TooltipComponent
      handle={weightText}
      position="right-bottom"
      renderContent={() => {
        return (
          <>
            <StatsTooltipRow
              label={t`Current Weight`}
              value={`${formatAmount(currentWeightBps, 2, 2, false)}%`}
              showDollar={false}
            />
            <StatsTooltipRow
              label={t`Target Weight`}
              value={`${formatAmount(targetWeightBps, 2, 2, false)}%`}
              showDollar={false}
            />
            <br />
            {currentWeightBps.lt(targetWeightBps) && (
              <div className="text-white">
                <Trans>
                  {tokenInfo.symbol} is below its target weight.
                  <br />
                  <br />
                  Get lower fees to{" "}
                  <Link to="/buy_clp" target="_blank" rel="noopener noreferrer">
                    buy CLP
                  </Link>{" "}
                  with {tokenInfo.symbol}, and to{" "}
                  <Link to="/trade" target="_blank" rel="noopener noreferrer">
                    swap
                  </Link>{" "}
                  {tokenInfo.symbol} for other tokens.
                </Trans>
              </div>
            )}
            {currentWeightBps.gt(targetWeightBps) && (
              <div className="text-white">
                <Trans>
                  {tokenInfo.symbol} is above its target weight.
                  <br />
                  <br />
                  Get lower fees to{" "}
                  <Link to="/trade" target="_blank" rel="noopener noreferrer">
                    swap
                  </Link>{" "}
                  tokens for {tokenInfo.symbol}.
                </Trans>
              </div>
            )}
            <br />
            <div>
              <ExternalLink href="https://cadenceprotocol.gitbook.io/cadence-protocol/achievements-and-rewards/vesting-rewards">
                <Trans>More Info</Trans>
              </ExternalLink>
            </div>
          </>
        );
      }}
    />
  );
};
